import React, { useState, useContext } from 'react';

import AppContext from '../../context/AppContext';
import TabBar from '../../shared/TabBar';
import ProfileTab from './tabs/Profile';
import ObjectiveTab from './tabs/Objective';
import WorkTab from './tabs/Work';
import EducationTab from './tabs/Education';
import AwardsTab from './tabs/Awards';
import CertificationsTab from './tabs/Certifications';
import SkillsTab from './tabs/Skills';
import ExtrasTab from './tabs/Extras';
import LanguagesTab from './tabs/Languages';
import ReferencesTab from './tabs/References';

import TemplatesTab from '../../components/RightSidebar/tabs/Templates';
import ColorsTab from '../../components/RightSidebar/tabs/Colors';
import FontsTab from '../../components/RightSidebar/tabs/Fonts';
import ActionsTab from '../../components/RightSidebar/tabs/Actions';

const tabs = [
  'Actions',
  'Templates',
  'Colors',
  'Fonts',
  'Profile',
  'Objective',
  'Work Experience',
  'Education',
  'Awards',
  'Certifications',
  'Skills',
  'Languages',
  'References',
  'Extras',
];

const tabIcons = {
  'Actions': 'bolt',
  'Profile': 'face',
  'Objective': 'center_focus_strong',
  'Work Experience': 'business_center',
  'Education': 'school',
  'Awards': 'emoji_events',
  'Certifications': 'card_membership',
  'Skills': 'construction',
  'Languages': 'translate',
  'References': 'group',
  'Extras': 'extension',
  'Templates': 'dashboard',
  'Colors': 'palette',
  'Fonts': 'font_download',
};

const LeftSidebar = () => {
  const context = useContext(AppContext);
  const { state, dispatch } = context;
  const { data, theme } = state;

  const [currentTab, setCurrentTab] = useState('Actions');
  const onChange = (key, value) => {
    dispatch({
      type: 'on_input',
      payload: {
        key,
        value,
      },
    });

    dispatch({ type: 'save_data' });
  };

  const renderTabs = () => {
    switch (currentTab) {
      case 'Profile':
        return <ProfileTab data={data} onChange={onChange} theme="light" />;
      case 'Objective':
        return <ObjectiveTab data={data} onChange={onChange} theme="light" />;
      case 'Work Experience':
        return <WorkTab data={data} onChange={onChange} theme="light" />;
      case 'Education':
        return <EducationTab data={data} onChange={onChange} theme="light" />;
      case 'Awards':
        return <AwardsTab data={data} onChange={onChange} theme="light" />;
      case 'Certifications':
        return <CertificationsTab data={data} onChange={onChange} theme="light" />;
      case 'Skills':
        return <SkillsTab data={data} onChange={onChange} theme="light" />;
      case 'Languages':
        return <LanguagesTab data={data} onChange={onChange} theme="light" />;
      case 'References':
        return <ReferencesTab data={data} onChange={onChange} theme="light" />;
      case 'Extras':
        return <ExtrasTab data={data} onChange={onChange} theme="light" />;
      case 'Templates':
        return <TemplatesTab theme={theme} onChange={onChange} sidebarTheme="light" />;
      case 'Colors':
        return <ColorsTab theme={theme} onChange={onChange} sidebarTheme="light" />;
      case 'Fonts':
        return <FontsTab theme={theme} onChange={onChange} sidebarTheme="light" />;
      case 'Actions':
        return <ActionsTab data={data} theme="light" dispatch={dispatch} />;
      default:
        return null;
    }
  };

  return (
    <div
      id="leftSidebar"
      className="z-10 h-auto lg:h-full col-span-1 lg:col-span-2 shadow-2xl lg:rounded-none lg:border-r flex flex-col lg:flex-row overflow-hidden bg-white border-gray-200"
    >
      <div className="lg:h-full overflow-y-auto border-r hidden lg:block bg-white border-gray-200">
        <TabBar
          tabs={tabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          vertical={true}
          icons={tabIcons}
          theme="light"
        />
      </div>

      {/* Mobile Tab Bar */}
      <div className="lg:hidden block py-4">
        <TabBar
          tabs={tabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
      </div>

      <div className="flex-1 h-full overflow-y-scroll px-8 py-6 bg-gray-50 text-gray-900">
        {renderTabs()}
      </div>
    </div>
  );
};

export default LeftSidebar;
